import api from 'api'
import { CACHE_TAG_WORK_ORDER_CONTAINER_LIST, CACHE_TAG_WORK_ORDER_CONTAINER_VERSION_LIST } from 'api/cacheTagTypes'
import { stampPlacementFlagsOnList } from 'components/inventory/containers/__mocks__/placementFlags'

import type { ContainerListResponseApi } from 'types/api/container/container'
import type { WorkOrderContainerLinkArgs } from 'types/api/container/containerRequests'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getWorkOrderContainers: builder.query<ContainerListResponseApi, { workOrderId: string }>({
      query: ({ workOrderId }) => ({
        url: `/api/v1/core/work-orders/${workOrderId}/container`,
        method: 'GET',
      }),
      transformResponse: stampPlacementFlagsOnList<ContainerListResponseApi>,
      providesTags: [CACHE_TAG_WORK_ORDER_CONTAINER_LIST],
    }),
    // Per-WO disable/restore is WO assignment: unassign keeps the container on the service but drops it from this WO; Envers-audited.
    assignWorkOrderContainer: builder.mutation<ContainerListResponseApi, WorkOrderContainerLinkArgs>({
      query: ({ workOrderId, ...rest }) => ({
        url: `/api/v1/core/work-orders/${workOrderId}/container/assign`,
        method: 'POST',
        body: { ...rest },
      }),
      invalidatesTags: [CACHE_TAG_WORK_ORDER_CONTAINER_LIST, CACHE_TAG_WORK_ORDER_CONTAINER_VERSION_LIST],
    }),
    unassignWorkOrderContainer: builder.mutation<ContainerListResponseApi, WorkOrderContainerLinkArgs>({
      query: ({ workOrderId, ...rest }) => ({
        url: `/api/v1/core/work-orders/${workOrderId}/container/unassign`,
        method: 'POST',
        body: { ...rest },
      }),
      invalidatesTags: [CACHE_TAG_WORK_ORDER_CONTAINER_LIST, CACHE_TAG_WORK_ORDER_CONTAINER_VERSION_LIST],
    }),
  }),
})

export const {
  useGetWorkOrderContainersQuery,
  useLazyGetWorkOrderContainersQuery,
  useAssignWorkOrderContainerMutation,
  useUnassignWorkOrderContainerMutation,
} = extendedApi
